import { dataPaperPlane } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPaperPlane = /*#__PURE__*/createIcon(dataPaperPlane)
export default IconPaperPlane
